/**
 * @description: 给传入的数字添加px单位
 * @param {string | number}
 * @return {string}
 */
var addPxUnit = function addPxUnit(value) {
  return isNaN(Number(value)) ? String(value) : "".concat(value, "px");
};
/**
 * @description: 将对象转换成数组
 * @param {*}
 * @return {*}
 */
var toArray = function toArray(item) {
  return Array.isArray(item) ? item : [item];
};

export { addPxUnit, toArray };
